export default "assets/images/icons/chevron-light-3c1c1062.svg";